const LIST_STYLE_PROPERTIES = [
  'listLabelFontSize',
  'listLabelFontFamily',
  'listLabelColor',
  'listCheckboxColor',
  'listDescriptionColor',
]

/**
 * Form tool list opt-in properties for Unlayer.
 * When contact list subscription mode is off, hide the entire Lists panel
 * (including Font Size / Font Family / color options).
 */
export const getFormToolListProperties = (lists = []) => {
  const listsEnabled = !!window.isContactListSubscriptionMode

  if (!listsEnabled) {
    return {
      lists: { editor: { enabled: false } },
      ...LIST_STYLE_PROPERTIES.reduce((acc, key) => {
        acc[key] = { editor: { enabled: false } }
        return acc
      }, {}),
    }
  }

  return {
    lists: {
      editor: {
        data: {
          listsEnabled: true,
          availableLists: lists.map(l => ({
            id: l.id,
            name: l.displayName || l.name,
            description: l.description,
          })),
        },
      },
    },
  }
}
